export default {"src":"/_next/static/media/logo-hh.35a5bf0d.svg","height":25,"width":26};